import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import history from 'shared_history';

const withPagination = (WrappedComponent) => {
  const PaginatedComponent = (props) => {
    const { location } = props;
    const query = queryString.parse(location.search);
    const page = parseInt(query.page, 10) || 1;

    /** Change the page in the URL on pagination click */
    const setPage = (newPage) => {
      const newQuery = {
        ...query,
        page: newPage
      };

      history.push({
        ...location,
        search: `?${queryString.stringify(newQuery)}`
      });
    };

    return <WrappedComponent {...props} page={page} setPage={setPage} />;
  };

  PaginatedComponent.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string
    }).isRequired
  };

  return PaginatedComponent;
};

withPagination.propTypes = {
  WrappedComponent: PropTypes.element
};

export default withPagination;
